export const ACTIVE_FILTER_ACCORDION_TOGGLE_FILTER = 'ACTIVE_FILTER_ACCORDION_TOGGLE_FILTER';
